export const formatTimestamp = (timestamp: string): string => {
  const cleanTimestamp = timestamp.replace(/[[\]()\s]/g, '');
  const timeParts = cleanTimestamp.split(':').map(Number);

  if (timeParts.length === 2) {
    const [minutes, seconds] = timeParts;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
      2,
      '0'
    )}`;
  }
  if (timeParts.length === 3) {
    const [hours, minutes, seconds] = timeParts;
    return hours === 0
      ? `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
          2,
          '0'
        )}`
      : `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
          2,
          '0'
        )}:${String(seconds).padStart(2, '0')}`;
  }

  return timestamp;
};

export const secondsToTimestamp = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  return [hours, minutes, remainingSeconds]
    .map((n) => n.toString().padStart(2, '0'))
    .join(':');
};

export const convertTimestampToSeconds = (timestamp: string): number => {
  const cleanTimestamp = timestamp.replace(/[[\]()\s]/g, '');
  const timeParts = cleanTimestamp.split(':').map(Number);

  if (timeParts.length === 2) {
    const [minutes, seconds] = timeParts;
    return minutes * 60 + seconds;
  }
  if (timeParts.length === 3) {
    const [hours, minutes, seconds] = timeParts;
    return hours * 3600 + minutes * 60 + seconds;
  }

  return 0;
};
